var e={flexDirection:{value:"column"},input:{textAlign:{value:"center"}}};export{e as stepperfield};
